import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { GroupsAddEventComponent } from "./groups-add-event/groups-add-event.component";
import { GroupsEditEventComponent } from "./groups-edit-event/groups-edit-event.component";
import { DataService_DefineEvents } from "./shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-define-events",
	templateUrl: "./define-events.component.html",
	styleUrls: ["./define-events.component.css"],
})
export class DefineEventsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private defineService: DataService_DefineEvents,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchoolist(); //Also loads events

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	SchoolLoading: any = true;
	Saving: any = false;

	SchoolID: any = -1;
	lstSchool: any = [];
	StartDate: Date = new Date();
	EndDate: Date = new Date();
	Active: any = 2;
	lstActive: any = [
		{
			ID: 2,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	ActiveText: any = "Deactivate Event";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = true;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedEvent: any;
	lstEvent: any = [];

	//Filter lists
	lstRecurranceTypeDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "EventDescShort", header: "Event Name" },
		{ field: "EventDescLong", header: "Description" },
		{ field: "EventLocation", header: "Location" },
		{ field: "EventDTDesc", header: "Start Date" },
		{ field: "EndDTDesc", header: "End Date" },
		{ field: "RecurranceTypeDesc", header: "Occurrence" },
		{ field: "ActiveDesc", header: "Active" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	private loadSchoolist() {
		this.SchoolLoading = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				if (this.lstSchool.length > 0) {
					this.SchoolID = this.lstSchool[0].SchoolID;
				}

				this.SchoolLoading = false;

				this.loadEvent();
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	loadEvent() {
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}

		this.loading = true;
		var result = this.defineService.C9EventAndScheduleGetList(this.SchoolID, fsDate, feDate, this.Active);
		result.subscribe(
			(response) => {
				this.lstEvent = response;

				for (var i = 0; i < this.lstEvent.length; i++) {
					var next = this.lstEvent[i];

					next.ID = i; //Unique (One time have EventID, Recurring have ScheduleID and no EventID)

					next.EventDescShort = next.EventDescription.EventDescShort;
					next.EventDescLong = next.EventDescription.EventDescLong;
					next.EventLocation = next.EventDescription.EventLocation;
					next.EventDTDesc = moment(new Date(next.EventDT)).format("MM/DD/YYYY");
					next.EndDTDesc =
						next.EndDT != "0001-01-01T00:00:00"
							? moment(new Date(next.EndDT)).format("MM/DD/YYYY")
							: moment(new Date(next.EventDT)).format("MM/DD/YYYY");
					next.ActiveDesc = next.Active == true ? "Active" : "Inactive";
				}

				//Load Data Filter Lists
				this.lstRecurranceTypeDesc = Array.from(new Set(this.lstEvent.map((item: any) => item.RecurranceTypeDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstEvent.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadEvent();
	}

	//Custom Button Methods
	onAddEvent() {
		this.errorMessage = "";

		var ref = this.dialogService.open(GroupsAddEventComponent, {
			header: "Add Event",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadEvent();
			}
		});
	}

	onEditEvent() {
		this.errorMessage = "";

		if (this.SelectedEvent == undefined) {
			this.errorMessage = "Select an event to edit";
			return;
		}

		var Header = "";
		if (this.SelectedEvent.EventID > 0) {
			Header = "Edit Event";
		} else if (this.SelectedEvent.ScheduleID > 0) {
			Header = "Edit Schedule";
		}

		var ref = this.dialogService.open(GroupsEditEventComponent, {
			header: Header,
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
				EventID: this.SelectedEvent.EventID,
				ScheduleID: this.SelectedEvent.ScheduleID,
				EventDescriptionID: this.SelectedEvent.EventDescription.EventDescriptionID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadEvent();
			}
		});
	}

	onDeleteEvent() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedEvent == undefined) {
			this.errorMessage = "Select an event to delete";
			return;
		}

		this.ConfirmDelete();
	}

	ConfirmDelete() {
		var MSG: any = "";

		if (this.SelectedEvent.ScheduleID > 0) {
			MSG = "Are you sure you want to delete this schedule?";
		} else {
			MSG = "Are you sure you want to delete this event?";
		}

		this.confirmationService.confirm({
			key: "main",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				//Recurring Event
				if (this.SelectedEvent.ScheduleID > 0) {
					this.DeleteSchedule();
				}
				//Normal/One time Event
				else {
					this.EventCheckAssigned();
				}
			},
			reject: () => {
				return;
			},
		});
	}

	DeleteSchedule() {
		var result = this.defineService.C9ScheduleDelete(this.SelectedEvent.ScheduleID);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "maindelete",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Schedule deleted successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadEvent();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "maindelete",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Schedule",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	EventCheckAssigned() {
		//Call SP to check if event has students

		var result = this.defineService.C9EventInUse(this.SelectedEvent.EventID);
		result.subscribe(
			(response) => {
				if (response) {
					var MSG: any =
						"The Event '" +
						this.SelectedEvent.EventDescription.EventDescShort +
						"' cannot be deleted because it has Event Scan entries. Please delete the scans and try again.";

					this.confirmationService.confirm({
						key: "mainwarn",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							return;
						},
					});
				} else {
					this.FinishDeleteEvent();
				}
			},
			(error) => {}
		);
	}

	FinishDeleteEvent() {
		var result = this.defineService.C9DeleteEvent(this.SelectedEvent.EventID);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "maindelete",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Event deleted successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.onRowUnselect(null);
							this.loadEvent();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "maindelete",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Event",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.onRowUnselect(null);
						},
					});
				}
			},
			(error) => {}
		);
	}

	onToggleEvent() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedEvent == undefined) {
			this.errorMessage = "Select an event to activate or deactivate";
			return;
		}

		if (this.SelectedEvent.ScheduleID > 0) {
			this.ToggleSchedule();
		} else {
			this.ToggleEvent();
		}
	}

	ToggleEvent() {
		//Call SP

		var changeTo = this.SelectedEvent.Active == 1 ? 0 : 1;

		var result = this.defineService.DefineEventSetActive(this.SelectedEvent.EventID, changeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadEvent();
				} else {
					var MSG: any = "";

					if (changeTo == 1) {
						MSG = "Could not activate the event";
					} else {
						MSG = "Could not deactivate the event";
					}

					//Fail Dialog
					this.confirmationService.confirm({
						key: "maindelete",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.onRowUnselect(null);
						},
					});
				}
			},
			(error) => {}
		);
	}

	ToggleSchedule() {
		//Call SP
		var changeTo = this.SelectedEvent.Active == 1 ? 0 : 1;

		var result = this.defineService.C9ScheduleSetActive(this.SelectedEvent.ScheduleID, changeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadEvent();
				} else {
					var MSG: any = "";

					if (changeTo == 1) {
						MSG = "Could not activate the schedule";
					} else {
						MSG = "Could not deactivate the schedule";
					}

					//Fail Dialog
					this.confirmationService.confirm({
						key: "maindelete",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.onRowUnselect(null);
						},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		this.errorMessage = "";

		this.SchoolID = val;

		this.loadEvent();
	}

	onStartDateChange(val) {
		this.errorMessage = "";

		this.StartDate = val;

		this.loadEvent();
	}

	onEndDateChange(val) {
		this.errorMessage = "";

		this.EndDate = val;

		this.loadEvent();
	}

	onActiveChange(val) {
		this.errorMessage = "";

		this.Active = val;

		this.loadEvent();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedEvent = val.data;

		if (this.SelectedEvent.Active == 0) {
			this.ActiveText = "Activate Event";
		} else {
			this.ActiveText = "Deactivate Event";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.ActiveText = "Deactivate Event";

		this.SelectedEvent = null;
	}
	onRowDblClick(Event) {
		this.errorMessage = "";

		this.SelectedEvent = Event;

		if (this.SelectedEvent.Active == 0) {
			this.ActiveText = "Activate Event";
		} else {
			this.ActiveText = "Deactivate Event";
		}

		this.onEditEvent();
	}
	////////////////////////////////////////////
}
